
export enum NetworkType {
    None = 'Unknown',
    Ethernet = 'Ethernet',
    Wifi = 'Wifi'
}